// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37JBh","select":"styles_select__2_cOW"};